import type React from 'react';

import { ArticleCard } from '../article-card';

import {
  TITLE,
  TEXT_CONTENT,
  BULLET_POINTS,
  SECOND_TEXT_CONTENT,
  data,
} from './cover-letter-section-data';
import {
  Container,
  Title,
  Text,
  CardContainer,
  BulletPointsContainer,
  BulletPointTitle,
  BulletPointBody,
} from './cover-letter-section.styles';

export const CoverLetterSection: React.FC = () => (
  <Container>
    <Title size="xxlarge">{TITLE}</Title>
    {/* @ts-expect-error FIXME: SC6 */}
    <Text size="xlarge" dangerouslySetInnerHTML={{ __html: TEXT_CONTENT }} />
    <BulletPointsContainer>
      <ul>
        {BULLET_POINTS.map((item, index) => {
          return (
            <BulletPointTitle
              noMargin={index === BULLET_POINTS.length - 1}
              key={item.headline}
            >
              {item.headline}
              <BulletPointBody size="xlarge">{item.body}</BulletPointBody>
            </BulletPointTitle>
          );
        })}
      </ul>
    </BulletPointsContainer>
    {/* @ts-expect-error FIXME: SC6 */}
    <Text
      size="xlarge"
      dangerouslySetInnerHTML={{ __html: SECOND_TEXT_CONTENT }}
    />
    <CardContainer>
      <ArticleCard {...{ data }} section="anschreiben" />
    </CardContainer>
  </Container>
);
